<template>
  <div class="product_inf" style="">
    <card
      title="品质承诺"
      >
      <div class="product_inf_content" style="padding:0rem 2rem 0.6rem 1.8rem;">
        <span
          class="inlineblock width100 yellowfont minfont widthStyle"
          v-html="commitmentToQuality">
        </span>
      </div>
    </card>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'

  export default {
    name: '',
    components: { card },
    props: {
      commitmentToQuality: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
      }
    },
    methods: {}
  }
</script>


<style lang="less" scoped>
.widthStyle {
  width: 14rem;
  word-wrap: break-word;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}

.red-text {
  color: red;
  font-weight: bold;
}
</style>
